export function AutoUnsubscribe( constructor ) {

  const original = constructor.prototype.ngOnDestroy;

  constructor.prototype.ngOnDestroy = function() {
    for (const prop in this) {
      if (this[prop]) {
        const property = this[prop];
        if (property && (typeof property.unsubscribe === 'function')) {
          property.unsubscribe();
        }
      }
    }
    if (original && typeof original === 'function') {
      original.apply(this, arguments);
    }
  };

}



// WEBPACK FOOTER //
// ./src/app/models/decorators/auto-unsubscribe.ts